import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialTable from "../../Components/Table/MaterialTable";
import { tableEye } from "../../common/Assets/imgs";
import { FaSearch } from "react-icons/fa";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";
// import { toast } from "react-toastify";

const TransportBookings = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const { type, datas } = location.state || {};
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState(1);
  const tabs = [
    { name: "Transport Details", path: "/view-transport" },
    { name: "Vehicles", path: "/vehicle-transport" },
    { name: "Drivers", path: "/drivers-transport" },
    { name: "Bookings", path: "/transport-bookings" },
  ];

  console.log("location", datas);

  const statusChanger = (id, currentStatus) => {
    put(`${URLS.TRANSPORT_DRIVER_STATUS}${id}/`, {
      status: currentStatus === true ? false : true,
    })
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message);

          getList(search, pagination); // refresh table
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const [adminList, setAdminList] = useState([]);

  const formatDate = (isoString) => {
  const date = new Date(isoString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert 0 → 12

  return `${day}-${month}-${year}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const pageSize = 10;

  const columns = [
    {
      header: "S.No",
           accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
      // accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    {
      accessorKey: "order_id",
      header: "Order ID",
    },
    {
      accessorKey: "pickup",
      header: "Pickup",
       Cell: ({ row }) => {
        const text = row.original.pickup || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "drop",
      header: "Drop",
       Cell: ({ row }) => {
        const text = row.original.drop || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "trip_price",
      header: "Trip Price",
    },
    {
      accessorKey: "date_time",
      header: "Date & Time",
       Cell: ({ cell }) => (
        <span 
        // style={{ color: "green", fontWeight: 600 }}
        >
          {formatDate(cell.getValue())}
        </span>
       ),
    },
    // {
    //   accessorKey: "trip_price",
    //   header: "Trip Price",
    // },

    {
      accessorKey: "status",
      header: "Status",
      Cell: ({ cell, row }) => {
        return (

          <span
            onClick={() => statusChanger(row?.original?.id, row?.original?.status)}
          >
            {cell.getValue()}
          </span>
        );
      },
    },

  ];



  // ----------- BACK BUTTON -----------
  const handleBack = () => {
    navigation(-1);
  };

  const handleTabClick = (tab) => {
    navigation(tab.path, { state: { datas, type } });
  };

  const getList = async (src, page) => {
    try {
      const res = await get(`${URLS.VEHICLE_TRANSPORT_BOOKINGS_LIST}${datas?.id}/?search=${src}&page=${page}`);
      console.log('res', res);
      if (res?.results?.status === "success") {
        setAdminList(res?.results?.data || [])
      }
    }
    catch (err) {
      console.log('err', err);

    }
  }

  useEffect(() => {
    getList(search, pagination);
  }, [search, pagination])

  console.log("adminList", adminList);


  return (
    <>
      <Header />
      <div
        style={{
          marginTop: "6rem",
          paddingLeft: "15px",
          paddingRight: "10px",
        }}
      >
        {/* <div className="section">
          <h3 onClick={handleBack} className="section-titlez mb-0">
            Swift way Transports
          </h3>
        </div> */}

        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">

          {/* LEFT TITLE */}
          {/* <h3 className="m-0 fw-bold fs-5 text-black">Vehicle Master</h3> */}
          <div className="section">
            <h3 onClick={handleBack} className="section-titlez mb-0">
              {/* Swift way Transports */}
              {datas?.transport_name || ''}
            </h3>
          </div>
          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">

            {/* SEARCH BOX */}
            <div className="search-box d-flex align-items-center px-3"
            >
              <input
                type="text"
                placeholder="Search"
                className="border-0 outline-none bg-transparent"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="ms-2 searchdote" >|</div>
              <FaSearch color='#7A52AB' className="ms-1" />
            </div>

            {/* ADD BUTTON */}
            <button onClick={() => navigation('/adddrivers-transport',
              {
                state: {
                  type: "add",
                  datas
                }
              }
            )} style={{ backgroundColor: "#F98425" }} className="btn text-white fw-semibold px-4 py-2">
              + Add Drivers
            </button>

          </div>

        </div>

        {/* Tabs */}
        <div className="tabs mb-0 ms-3">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => handleTabClick(tab)}
              className={`tab-btn ${location.pathname === tab.path ? "active" : ""
                }`}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <MaterialTable columns={columns} data={adminList || []} />

      </div>
    </>
  );
};

export default TransportBookings;
